import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useRouter, useUIComponents, useTranslate, use, I18NService, } from "@bluelibs/x-ui";
import { useState, useMemo } from "react";
import { useMutation, useQuery } from "@apollo/client";
import * as Ant from "antd";
import { PlusOutlined, DownOutlined } from "@ant-design/icons";
import { Routes } from "@bundles/UIAppBundle";
import { features } from "../../config/features";
import { ADMIN_WINERY_MEMBER_GROUP_DELETE, ADMIN_WINERY_MEMBER_GROUP_GET_ALL, } from "@bundles/UIAppBundle/queries";
export function WineriesList() {
    const UIComponents = useUIComponents();
    const router = useRouter();
    const t = useTranslate();
    const i18n = use(I18NService);
    const [filtersOpened, setFiltersOpened] = useState(false);
    const [messageApi, contextHolder] = Ant.message.useMessage();
    const { refetch, data, error, loading } = useQuery(ADMIN_WINERY_MEMBER_GROUP_GET_ALL);
    const [deleteGroup] = useMutation(ADMIN_WINERY_MEMBER_GROUP_DELETE);
    const handleDeleteWinery = (id) => {
        deleteGroup({ variables: { input: { wineryId: id } } })
            .then(() => {
            messageApi.open({
                type: "success",
                content: "Winery deleted successfully",
            });
            refetch();
        })
            .catch((e) => {
            messageApi.open({
                type: "error",
                content: e.message,
            });
        });
    };
    const items = (id) => [
        {
            key: "view",
            label: "View",
            onClick: () => {
                router.go({ path: `${router.history.location.pathname}/${id}/view` });
            },
        },
        {
            key: "edit",
            label: "Edit",
            onClick: () => {
                router.go({ path: `${router.history.location.pathname}/${id}/edit` });
            },
        },
        {
            key: "delete",
            label: (_jsx(Ant.Popconfirm, Object.assign({ title: "Sure to delete?", onConfirm: () => handleDeleteWinery(id) }, { children: _jsx("a", { children: "Delete" }, void 0) }), void 0)),
        },
    ];
    const tableDataSource = useMemo(() => {
        var _a;
        const dataSource = (_a = data === null || data === void 0 ? void 0 : data.AdminWineryGetAll) !== null && _a !== void 0 ? _a : [];
        const columns = [
            {
                title: "Name",
                dataIndex: "name",
                key: "name",
                fixed: "left",
            },
            {
                title: i18n.t("generics.list_actions"),
                key: "actions",
                fixed: "right",
                width: 150,
                render: (item) => {
                    return (_jsx(Ant.Space, Object.assign({ size: "middle" }, { children: _jsx(Ant.Dropdown, Object.assign({ menu: { items: items(item._id) } }, { children: _jsxs(Ant.Button, { children: [_jsx(DownOutlined, {}, void 0), " Actions"] }, void 0) }), void 0) }), void 0));
                },
            },
        ];
        return {
            dataSource,
            columns,
        };
    }, [data, loading]);
    return (_jsxs(UIComponents.AdminLayout, { children: [contextHolder, _jsx(Ant.PageHeader, { title: t("management.wineries.list.header"), extra: [
                    features.create ? (_jsx(Ant.Button, Object.assign({ onClick: () => router.go(Routes.WINERIES_CREATE), icon: _jsx(PlusOutlined, {}, void 0) }, { children: t("management.wineries.list.create_btn") }), "1")) : null,
                    // <Ant.Button
                    //   key="2"
                    //   onClick={() => setFiltersOpened(!filtersOpened)}
                    //   icon={<FilterOutlined />}
                    // >
                    //   {t("generics.list_filters")}
                    // </Ant.Button>,
                ] }, void 0), error && _jsx(Ant.Alert, { type: "error", message: error }, void 0), _jsx(Ant.Layout.Content, { children: _jsx("div", Object.assign({ className: "page-wineryMember-groups-list" }, { children: _jsx(Ant.Table, Object.assign({}, tableDataSource, { pagination: false, className: "page-wineryMember-groups-list-table", loading: loading }), void 0) }), void 0) }, void 0)] }, void 0));
}
